<div class="container py-4">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="text-primary mb-0">
      <i class="fa-solid fa-receipt me-2"></i>Pagos del Cliente
    </h3>
    <button class="btn btn-outline-secondary" (click)="volverACliente()">
      <i class="fa-solid fa-arrow-left me-2"></i>Volver
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center my-5">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-2 text-muted">Cargando pagos del cliente...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <!-- Sin pagos -->
  <div *ngIf="!loading && !error && payments.length === 0" class="alert alert-warning text-center">
    <i class="fa-solid fa-circle-exclamation me-2"></i>
    No hay pagos registrados para este cliente.
  </div>

  <!-- Tabla de pagos -->
  <div *ngIf="!loading && payments.length > 0" class="card shadow-sm border-0">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Fecha</th>
              <th>Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pago of payments; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ pago.fecha | date:'short' }}</td>
              <td class="text-success fw-bold">${{ pago.monto | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
